module.exports = __webpack_public_path__ + "img/7.37daf1be.png";